<template>
  <div>
    <div class="header pb-8 pt-lg-8 d-flex align-items-center profile-header">
      <b-container fluid>
        <span class="mask bg-gradient-success opacity-8"></span>

        <b-container fluid class="d-flex align-items-center">
          <b-row>
            <b-col lg="7" md="10"> </b-col>
          </b-row>
        </b-container>
      </b-container>
    </div>

    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <card>
            <b-row align-v="center" slot="header">
              <b-col cols="8">
                <base-button
                  @click="tipoFormulario = 1"
                  size="lg"
                  :type="tipoFormulario == 1 ? 'primary' : 'secondary'"
                  >Gestion Catecumenos</base-button
                >
                <base-button
                  @click="tipoFormulario = 2"
                  size="lg"
                  :type="tipoFormulario == 2 ? 'primary' : 'secondary'"
                  >Padres</base-button
                >
                <base-button
                  @click="tipoFormulario = 3"
                  size="lg"
                  :type="tipoFormulario == 3 ? 'primary' : 'secondary'"
                  >Madres</base-button
                >
                <base-button
                  @click="tipoFormulario = 4"
                  size="lg"
                  :type="tipoFormulario == 4 ? 'primary' : 'secondary'"
                  >Gestion Colegios</base-button
                >
              </b-col>
            </b-row>
            <vista-catecumenos v-if="tipoFormulario == 1" />
            <vista-padres
              v-if="tipoFormulario == 2 || tipoFormulario == 3"
              :tipoFormulario="tipoFormulario"
            />
            <vista-colegios v-if="tipoFormulario == 4"></vista-colegios>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>

import VistaColegios from "@/views/GestionCatequesis/Vistas/VistaColegios.vue";
import VistaPadres from "@/views/GestionCatequesis/Vistas/VistaPadres.vue";
import VistaCatecumenos from "@/views/GestionCatequesis/Vistas/VistaCatecumenos.vue";

export default {
  name: "gestionCatecumenos",
  components: {
    VistaColegios,
    VistaCatecumenos,
    VistaPadres
  },
  props: {},
  data() {
    return {
      tipoFormulario: 1,
    };
  },
};
</script>
<style></style>
